import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Fiat, Offer } from "@models";
import { ICashPlusFiatWallet } from "@modules/cashplus/entities/cashplus.model";
import { Big } from "big.js";

@Component({
	selector: "cashplus-summary-overview",
	templateUrl: "./cashplus-summary-overview.component.html",
	styleUrls: ["./cashplus-summary-overview.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class CashplusSummaryOverviewComponent {
	@Input() vm: ICashPlusFiatWallet;
	@Input() offer: Offer;
	@Input() fiat: Fiat;
	// Always true if cashplus is used
	@Input() isLessThanAmount: boolean;

	calculateFiatValue(
		isLessThanAmount: boolean,
		parkedAssetBalance: number,
		assetBalance: number,
		offerAmountFiat: number
	): number {
		if (!isLessThanAmount) {
			return 0;
		}

		const amount = new Big(offerAmountFiat);
		const parked = new Big(parkedAssetBalance); //cashplus only
		const available = new Big(assetBalance); //combination available + cashplus

		// Case 1: offer amount > parked balance → capped at parked balance
		if (amount.gte(parked)) {
			return Number(amount);
		}

		// Case 2: abs(available - offer)
		const walletBalance = available.minus(parked);
		if (walletBalance.gte(0)) {
			const subtractedWalletBalance = amount.minus(walletBalance);
			return Number(subtractedWalletBalance);
		}
		const result = available.minus(amount).abs();

		return Number(result);
	}
}
